import { objectSpread2 as _objectSpread2, taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useCallback } from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, TableRow, TableCell } from '@mui/material';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _templateObject;
var componentExpandedRow = createComponentSlot({
  name: "CinTable",
  slot: "ExpandedRow"
});

var ExpandedRowBase = function ExpandedRowBase(_ref) {
  var item = _ref.item,
      itemKey = _ref.itemKey,
      itemIndex = _ref.itemIndex,
      columnSpan = _ref.columnSpan,
      render = _ref.render,
      onCollapse = _ref.onCollapse,
      visible = _ref.visible;
  var onRowCollapse = useCallback(function () {
    if (onCollapse) onCollapse(itemKey);
  }, [itemKey, onCollapse]);
  var rowState = {
    itemKey: itemKey,
    itemIndex: itemIndex
  };
  var rowEvents = {
    onCollapse: onRowCollapse
  };
  if (!visible) return null;
  return /*#__PURE__*/React.createElement(TableRow, {
    className: classnames(componentExpandedRow.className, item.className)
  }, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: columnSpan
  }, render(item, rowState, rowEvents)));
};
/**
 * Renders an expanded row for a table data item
 */


ExpandedRowBase.propTypes = {
  item: propTypes.any.isRequired,
  itemKey: propTypes.any.isRequired,
  itemIndex: propTypes.number.isRequired,
  render: propTypes.func.isRequired,
  columnSpan: propTypes.number,
  onCollapse: propTypes.func,
  visible: propTypes.bool.isRequired
};
var ExpandedRow = styled(ExpandedRowBase, _objectSpread2(_objectSpread2({}, componentExpandedRow.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var ExpandedRow$1 = ExpandedRow;

export { ExpandedRow$1 as default };
